/**
 * Resolve a stored image path to a fully-qualified URL.
 * - http(s)://… → returned as-is (external CDN, e.g. Unsplash/Pexels)
 * - /api/uploads/… or other absolute paths → prepended with REACT_APP_BACKEND_URL
 * - empty/null → empty string
 */
export function mediaUrl(path) {
  if (!path) return "";
  if (path.startsWith("http://") || path.startsWith("https://")) return path;
  if (path.startsWith("/")) return `${process.env.REACT_APP_BACKEND_URL}${path}`;
  return path;
}
